import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchComponent } from './components/search-component/search.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { HttpLoaderFactory } from 'src/app/app.module';
import { HttpClient } from '@angular/common/http';
import { BtnActionModule } from '../btn-action/btn-action.module';



@NgModule({
  declarations: [
    SearchComponent,
  ],
  imports: [
    CommonModule,
    BtnActionModule,
    ReactiveFormsModule,
    TranslatePipe, TranslateDirective,
  ],
    exports: [SearchComponent],
})
export class SearchModule {}
